
import { Navbar, Nav as Zaboka, Container } from "react-bootstrap"

// Used Nav as zaboka because can't use nav and navbar together
export default function Nav(){
  const navLinkStyle = {
    fontSize: '20px', // Adjust the font size as needed
  };



// bootstrap navbar
    return (
 <Navbar bg="dark" data-bs-theme="dark"   >
        <Container>
          <Navbar.Brand href="/">ZBSPORTS</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" />

          <Zaboka className="me-auto">
            <Zaboka.Link href="/" style={navLinkStyle}>Home</Zaboka.Link>
            <Zaboka.Link href="/login" style={navLinkStyle}>Login</Zaboka.Link>
            <Zaboka.Link href="/signup" style={navLinkStyle}>Sign Up</Zaboka.Link>
          </Zaboka>
        </Container>
      </Navbar>
    )
}
